module.exports = __webpack_public_path__ + "static/media/Option2ProfPic.39678302.png";